import * as React from "react";
import styled from "styled-components";
import { useAuth } from "./providers/auth-context";
import admins from "../services/admins";

const BannerDiv = styled.div`
    width: 100%;
    height: 25px;
    position: fixed;
    top: 0;
    background-color: yellow;
    z-index: 10000;
    font-size: 12px;
    color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
`;

const DelegatedAccessBanner: React.FC = (): React.ReactNode | null => {
    const { user, jwt } = useAuth();

    const isDelegatedAccess =
        user && jwt && user.id !== jwt.sub && admins.find((admin) => admin.userId === jwt.sub);

    if (isDelegatedAccess)
        return (
            <BannerDiv>
                Currently in delegated access for user {user.emails?.[0]} {user.orgId}:{user.id}
            </BannerDiv>
        );
    return null;
};

export default DelegatedAccessBanner;
